<script>
  import {isNumber, isInteger} from '@/EventLogic/util';
  import chosen from '../directives/chosen';

  export default {
    directives: {
      chosen
    },
    props: {
      config: Object
    },
    data: function() {
      return {
        errors: {}
      };
    },
    methods: {
      isNumber,
      isInteger,
      validate: function() {
        return true;
      },
      // TODO: once a component has errors showing, re-run its own validate()
      // here on every change so they clear live instead of waiting for the
      // next submit attempt (see EventLogicConditionsList's condition-type
      // check for the pattern) - needs equivalent wiring in components that
      // don't extend BaseComponent (e.g. actions/message.vue).
      handleChange: function(event) {
        let val = event.target.value;

        if (event.target.tagName === 'SELECT' && event.target.multiple) {
          val = [].slice.call(event.target.selectedOptions).map(x => x.value);
        } else if (event.target.type === 'checkbox') {
          if (event.target.checked) {
            val = event.target.getAttribute('true-value') || true;
          } else {
            val = event.target.getAttribute('false-value') || false;
          }
        }

        this.$emit('update:' + event.target.name, val);
      }
    }
  };
</script>
